import React from "react"
import {
	Flex,
	INNER_MAX_WIDTH,
	NavigationPopup,
	Text,
} from "@capioweb/ui-components/src"
import { DesktopPrimaryMenu } from "./DesktopPrimaryMenu"
import { PrimaryMenuProps } from "../types"
import { HeaderContext } from "../context/HeaderContext"
import { AppContext, LocalesContext, UIContext } from "../../../context"
import { headerLogoSvg } from "@capioweb/ui-components/src/components/HeaderLogo/assets"
import {
	assetBaseUrl,
	isSessionStorageAvailable,
	sendLogInPopUpClickDataLayerPush,
} from "../../../utils"
import { SearchPopup } from "./SearchPopup"
import { Button, Icon, scale, Image } from "@capioweb/ui-components/src"

type DesktopHeaderXLProps = PrimaryMenuProps

const DesktopHeaderXL: React.FC<DesktopHeaderXLProps> = (props) => {
	const {
		showSearchPopup,
		setShowSearchPopup,
		showLoginWindowPopup,
		setShowLoginWindowPopup,
	} = React.useContext(HeaderContext)
	const { translate, translationKeys } = React.useContext(LocalesContext)
	const { loginPopUpModel, isLoggedIn } = React.useContext(AppContext)
	const { alternateHeaderLayout } = React.useContext(UIContext)
	const [showPopupAfterDelay, setShowPopupAfterDelay] = React.useState(false)

	//Show popup after 5 dec delay
	setTimeout(() => {
		setShowPopupAfterDelay(true)
	}, 5000)

	//Check if CTA popup should be shown
	const showLoginPopup =
		loginPopUpModel?.showPopUp &&
		showLoginWindowPopup &&
		!isLoggedIn &&
		showPopupAfterDelay

	return (
		<Flex
			display={{ _: "none", xl: props.hideLoginMenu ? "none" : "flex" }}
			w={1}
			maxw={INNER_MAX_WIDTH}
			style={{ margin: "0 auto" }}
			justifyContent="start"
			alignItems="center"
		>
			<a
				style={{ width: scale.px(13) }}
				href="/"
				aria-label="Tillbaka till startsidan"
			>
				<Image
					height={24}
					src={assetBaseUrl() + props.mainLogo ?? headerLogoSvg}
					alt="Capio"
				/>
			</a>
			<Flex w={1} alignItems="center" columnGap={2}>
				<DesktopPrimaryMenu menu={props.menu} />
				{(!props.hideSearch || !props.hideLoginMenu) && (
					<Flex columnGap={1} alignItems="center" justifyContent="end">
						{/* Search popup */}
						{!props.hideSearch && (
							<div style={{ position: "relative" }}>
								<Button
									onClick={() => {
										setShowSearchPopup(!showSearchPopup)
										setShowLoginWindowPopup(false)
									}}
									size={"medium"}
									variant="light-blue"
								>
									<Flex>
										<Icon
											mr={0.35}
											ml={-0.65}
											color="navy"
											icon="search"
											size={3}
										/>
									</Flex>
									{translate(translationKeys.search)}
								</Button>
								{showSearchPopup && (
									<SearchPopup
										label={translate(translationKeys.search)}
										showPopup={setShowSearchPopup}
									/>
								)}
							</div>
						)}
						{/* Login Popup */}

						<Flex position="relative">
							<Button.Anchor
								variant="navy"
								href={props.loginMenuItems[0]?.href}
								size="medium"
								onClick={() => {
									sendLogInPopUpClickDataLayerPush(
										props.loginMenuItems[0].text ?? ""
									)
									setShowLoginWindowPopup(false)
									if (isSessionStorageAvailable()) {
										sessionStorage.setItem("hideLoginPopup", "1")
									}
								}}
							>
								{props.loginMenuItems[0]?.text}
							</Button.Anchor>
							{loginPopUpModel?.popUpType === "MyPagesPopUp" && showLoginPopup && (
								<NavigationPopup
									heading={loginPopUpModel.header}
									size="small"
									isSearchPopup={false}
									showPopup={setShowLoginWindowPopup}
									arrowOffset="44px"
								>
									<Text my={2}>{loginPopUpModel.description}</Text>
									<Flex columnGap={3} alignItems="center">
										<Flex>
											<Button.Anchor
												variant="navy"
												key={loginPopUpModel?.loginLink?.contentLink?.id}
												my={1}
												href={loginPopUpModel?.loginLink?.href}
												style={{ width: "100%" }}
												onClick={() => {
													sendLogInPopUpClickDataLayerPush(
														loginPopUpModel?.popUpType ?? ""
													)
													setShowLoginWindowPopup(false)
													if (isSessionStorageAvailable()) {
														sessionStorage.setItem("hideLoginPopup", "1")
													}
												}}
											>
												{loginPopUpModel?.loginLink?.text}
											</Button.Anchor>
										</Flex>
										<Text.Link
											to={loginPopUpModel?.readMoreLink?.href}
											mb={0}
											underline
										>
											{translate(translationKeys.readMore)}
										</Text.Link>
									</Flex>
								</NavigationPopup>
							)}
						</Flex>
						{/* Capio online */}
						<Flex position="relative">
							<Button.Anchor
								variant={alternateHeaderLayout ? "ghost-navy" : "navy"}
								href={props.loginMenuItems[1]?.href}
								size="medium"
								onClick={() => {
									sendLogInPopUpClickDataLayerPush(
										props.loginMenuItems[1]?.text ?? ""
									)
									setShowLoginWindowPopup(false)
									if (isSessionStorageAvailable()) {
										sessionStorage.setItem("hideLoginPopup", "1")
									}
								}}
							>
								{props.loginMenuItems[1]?.text}
							</Button.Anchor>
							{loginPopUpModel?.popUpType === "CapioOnlinePopUp" &&
								showLoginPopup && (
									<NavigationPopup
										heading={loginPopUpModel.header}
										size="small"
										isSearchPopup={false}
										showPopup={setShowLoginWindowPopup}
										arrowOffset="105px"
									>
										<Text my={2}>{loginPopUpModel.description}</Text>
										<Flex columnGap={3} alignItems="center">
											<Flex>
												<Button.Anchor
													variant="navy"
													key={loginPopUpModel?.loginLink?.contentLink?.id}
													my={1}
													href={loginPopUpModel?.loginLink?.href}
													style={{ width: "100%" }}
													onClick={() => {
														sendLogInPopUpClickDataLayerPush(
															loginPopUpModel?.popUpType ?? ""
														)
														setShowLoginWindowPopup(false)
														if (isSessionStorageAvailable()) {
															sessionStorage.setItem("hideLoginPopup", "1")
														}
													}}
												>
													{loginPopUpModel?.loginLink?.text}
												</Button.Anchor>
											</Flex>
											<Text.Link
												to={loginPopUpModel?.readMoreLink?.href}
												mb={0}
												underline
											>
												{translate(translationKeys.readMore)}
											</Text.Link>
										</Flex>
									</NavigationPopup>
								)}
						</Flex>
					</Flex>
				)}
			</Flex>
		</Flex>
	)
}

export { DesktopHeaderXL }
